/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientSearchAddressResponseDto } from './ClientSearchAddressResponseDto';
import type { ClientSearchAdviserLinkResponseDto } from './ClientSearchAdviserLinkResponseDto';
export type ClientSearchResponseDto = {
    /**
     * Client ID
     */
    id: string;
    /**
     * First name or business name
     */
    firstName: string;
    /**
     * Last name (for individual clients)
     */
    lastName: string;
    /**
     * Date of birth (for individual clients)
     */
    dob?: string | null;
    /**
     * Client type
     */
    clientType: ClientSearchResponseDto.clientType;
    /**
     * Client status
     */
    status: ClientSearchResponseDto.status;
    /**
     * Primary phone number
     */
    phone: string;
    /**
     * Primary email address
     */
    email: string;
    /**
     * Ando customer ID
     */
    andoCustomerId?: string | null;
    /**
     * Assigned adviser ID
     */
    assignedAdviserId?: string | null;
    /**
     * Whether client is marked as vulnerable
     */
    isVulnerable: boolean;
    /**
     * Whether client has policies with other providers
     */
    hasMultiplePolicies: boolean;
    /**
     * Last client activity timestamp
     */
    lastActivity?: string | null;
    /**
     * Client created timestamp
     */
    createdAt: string;
    /**
     * Client updated timestamp
     */
    updatedAt: string;
    /**
     * Minimal adviser links for list display
     */
    adviserLinks?: Array<ClientSearchAdviserLinkResponseDto> | null;
    /**
     * Client addresses used for list/search display
     */
    addresses?: Array<ClientSearchAddressResponseDto> | null;
};
export namespace ClientSearchResponseDto {
    /**
     * Client type
     */
    export enum clientType {
        INDIVIDUAL = 'INDIVIDUAL',
        BUSINESS = 'BUSINESS',
    }
    /**
     * Client status
     */
    export enum status {
        IN_PROGRESS = 'IN_PROGRESS',
        BOUND = 'BOUND',
        LAPSED = 'LAPSED',
        RENEWAL_DUE = 'RENEWAL_DUE',
    }
}

